import React from 'react';

const statusConfig = {
    RECRUITING: {
        text: '모집중',
        backgroundColor: '#FFD700',
        textColor: '#663300'
    },
    CONFIRMED: {
        text: '확정',
        backgroundColor: '#E3F2FD',
        textColor: '#1565C0'
    },
    READY: {
        text: '확정',
        backgroundColor: '#E3F2FD',
        textColor: '#1565C0'
    },
    END: {
        text: '종료',
        backgroundColor: '#EEEEEE',
        textColor: '#757575'
    }
};

const MeetingStatusIndicator = ({ status }) => {
    const config = statusConfig[status] || statusConfig.RECRUITING;

    return (
        <div 
            className="px-2 py-1 rounded text-xs font-semibold"
            style={{
                backgroundColor: config.backgroundColor,
                color: config.textColor
            }}
        >
            {config.text}
        </div>
    );
};

export default MeetingStatusIndicator; 